module.exports = __webpack_public_path__ + "img/lib_region_flag_tm.72ddd13d.png";